import React, { ChangeEvent, ComponentProps } from "react";
import { Select } from "../../../components/input-functions";
import { AdvanceSalaryStatus } from "../../../dto";
import AdvanceSalaryMonthAndYearFilter from "./advanceSalaryMonthAndYearFilter";
import AdvanceSalaryStatusFilter from "./advanceSalaryStatusFilter";

const statusOptions: ComponentProps<typeof Select>["options"] = [
  { label: "Active", value: AdvanceSalaryStatus.ACTIVE },
  { label: "Closed", value: AdvanceSalaryStatus.CLOSED },
];

interface AdvanceSalaryFilterProps {
  selectedStatus: AdvanceSalaryStatus;
  selectedDate: Date | null;
  onDateChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSelectChange: ComponentProps<typeof Select>["onChange"];
}

export default function AdvanceSalaryFilters({
  selectedDate,
  selectedStatus,
  onSelectChange,
  onDateChange,
}: AdvanceSalaryFilterProps) {
  return (
    <div className="dashboard-container d-flex align-items-center justify-content-between p-3">
      <AdvanceSalaryStatusFilter
        status={selectedStatus}
        options={statusOptions}
        onChange={onSelectChange}
      />
      <AdvanceSalaryMonthAndYearFilter
        selectedDate={selectedDate}
        onChange={onDateChange}
      />
    </div>
  );
}
